import React from 'react';
import { TextField, makeStyles } from '@ui';
import { poNumberMaxLength } from './useUpdatePONumber';

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: '18px',
    border: `1px ${theme.palette.grey[400]} solid`,
    padding: theme.spacing(1),
  },
}));

export interface SafeTextareaProps {
  value: string;
  onChange: (text: string) => void;
}

const escape = (str: string) => str.replace(/"/g, '\\"');
const unescape = (str: string) => str.replace(/\\"/g, '"');

export const SafeTextarea: React.FC<SafeTextareaProps> = ({ value, onChange }) => {
  const classes = useStyles();
  const handleChange: React.ChangeEventHandler<HTMLTextAreaElement> = (e) =>
    onChange(escape(e.target.value));
  const helperText = `${
    poNumberMaxLength - value.length
  } of ${poNumberMaxLength} Characters available`;

  return (
    <TextField
      fullWidth
      multiline
      InputProps={{ classes, disableUnderline: true }}
      onChange={handleChange}
      rows={5}
      id='comment'
      value={unescape(value)}
      autoFocus
      helperText={helperText}
    />
  );
};
